import Skeleton from '@mui/material/Skeleton'
import withStyles from '@mui/styles/withStyles'

export default withStyles((theme) => ({
  rect: {
    backgroundColor: 'red',
    borderRadius: theme.shape.borderRadius,
  },
}))(Skeleton)
